import React from 'react';
import { Link } from 'react-router-dom';
import JetsweatPhoto from '../assets/images/JetsweatThumb2.jpg';
import MothPhoto from '../assets/images/MothThumb.jpg';
import FishWaterPhoto from '../assets/images/fishwaterborder.jpg';
import HotelFictionPhoto from '../assets/images/HotelFictionThumb.jpg';
import './NarrativePage.css';

function CommercialPage() {
  return (
    <div className="films-container">
      <div className="films-row">
        <Link to="/hotel-fiction" className="films-image-link">
          <div className="films-overlay-container">
            <img src={HotelFictionPhoto} alt="Hotel Fiction Concert Recap" className="films-image" />
            <div className="films-title">Hotel Fiction</div>
          </div>
        </Link>
        <Link to="/jetsweat" className="films-image-link">
          <div className="films-overlay-container">
            <img src={JetsweatPhoto} alt="Jetsweat" className="films-image" />
            <div className="films-title">Jetsweat</div>
          </div>
        </Link>
      </div>
      <div className="films-row">
        <Link to="/themoth" className="films-image-link">
          <div className="films-overlay-container">
            <img src={MothPhoto} alt="The Moth" className="films-image" />
            <div className="films-title">The Moth</div>
          </div>
        </Link>
        <Link to="/fish-out-of-water" className="films-image-link">
          <div className="films-overlay-container">
            <img src={FishWaterPhoto} alt="Fish Out of Water" className="films-image" />
            <div className="films-title">Fish Out of Water</div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default CommercialPage;
